<template>
  <Navbar class="bg-BGcolor2 z-10" />
  <div class="flex flex-col h-screen w-full">
  <div class="flex flex-row sm:flex-col w-full px-8 pt-32 ">
            <div class="flex flex-col w-1/5 sm:w-full pt-20 sm:pt-0 space-y-8 mr-8 sm:mr-0 text-center ">
        <div @click="$router.push('/lesson1')" class="flex ">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 1</p>
          <p class="text-xl sm:text-base md:text-lg 2xl:text-2xl pb-1">Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
        <div @click="$router.push('/lesson2')" class="flex">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full text-green-700 ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 2</p>
          <p class="text-xl sm:text-base md:text-lg 2xl:text-2xl pb-1">Reflection of Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
        <div @click="$router.push('/lesson3')" class="flex">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 3</p>
          <p class="text-xl sm:text-base md:text-lg 2xl:text-2xl  pb-1">Refraction of Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
        <div @click="$router.push('/lesson4')" class="flex">
          <button class="flex flex-col focus:outline-none space-y-2 items-center w-full ">
          <p class="text-2.5xl 2xl:text-3xl sm:text-lg md:text-xl">LESSON 4</p>
          <p class="text-xl sm:text-base 2xl:text-2xl md:text-lg pb-1">Dispersion of Light</p>
          <hr class="opacity-50 w-full sm:w-3/5 h-0.5 border-2 border-green-700">
          </button>
        </div>
      </div>
    <div class="flex flex-col w-4/5 space-y-8 sm:w-full sm:mt-20">
        <div class="w-4/5 sm:w-full mx-auto">
            <h1 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold leading-normal text-center">SPECULAR REFLECTION VS. DIFFUSE REFLECTION REFLECTION OF LIGHT</h1>
        </div>
        <div class="pt-14 sm:pt-10">
          <div
      class="bg-white w-100 sm:w-72 h-auto shadow border mx-auto border-black"
    >
    <div class="flex flex-col leading-loose justify-center px-12 py-8 space-y-6 sm:px-6 sm:py-4 sm:space-y-3">
      <p class=" font-bold text-xl sm:text-lg text-center">TABLE OF CONTENTS</p>
      <div class="flex flex-col text-lg sm:text-base">
        <p class="font-bold ">Introduction</p>
        <ul class="list-disc pl-5">
          <li>Brief History of Reflection</li>
        </ul>
      </div>
      <div class="flex flex-col text-lg sm:text-base">
        <p class="font-bold ">Experiments</p>
        <ul class="list-disc pl-5">
          <li>Specular vs. Diffuse with the use of water</li>
          <li>Specular vs. Diffuse with the use of mirror</li>
        </ul>
      </div>
      <div class="flex flex-col text-lg pb-5 sm:text-base">
        <p class="font-bold ">Reflection of Light</p>
        <ul class="list-disc pl-5">
          <li>What is Reflection of Light?</li>
          <li>Incident and Reflective Ray</li>
          <li>Specular Reflection vs Diffuse Reflection</li>
        </ul>
      </div>
    </div>
    </div>
        </div>
        
        <div class="flex flex-col space-y-8 p-4 leading-loose text-justify text-lg 2xl:text-xl sm:text-base">
            <p><span class="pl-9">Have</span> you ever wondered how you able to see things in this world with your eyes? Our ability to see through our eyes depends on the reflective properties of light. Without reflection, we would only be able to see luminous objects like the sun, light bulbs, and computer screens.</p>
            <p><span class="pl-9">The</span> old Greek mathematician Euclid depicted the law of reflection in around 300 BCE. This expresses that the light goes in straight lines and reflects from a surface at a similar edge at which it hit it. Euclid said that the light travels in rays that are discrete, like atoms, not continuous, like waves. Reflection of light happens when the waves experience a surface or other limit that does not retain the vitality of the radiation and bounces the waves from the surface. The approaching light wave is alluded as an incident wave, and the wave that is bounces from the surface is named reflected wave.</p>
            <p><span class="pl-9">B.</span> Aronov et. al. was presented the concept of the polygon visible by considering the two types of reflection which is the specular and the diffuse where they show the angle of incidence is equal to the angle of reflection. Specular reflection is one of the main types of reflection which is described as a mirror-like reflection of light from the surface. Meanwhile, the diffuse reflection of light or other waves or particles from a surface such that a ray incident on the surface is scattered at many angles rather than at just one angle as in the case of specular reflection.</p>
            <p><span class="pl-9">To</span> have a further understanding about the difference between specular reflection and diffuse reflection let us perform an experiment. There is a lot of laboratory experiment that you can do to explain any types of reflection of lights. That is why the material of this experiment can only be found inside the house. Also, this is easy to perform because it is designed by “DIY” or “Do It Yourself”.</p>
        </div>

        <div class="flex flex-row sm:flex-col md:flex-col sm:space-x-0 sm:items-center sm:space-y-8 md:space-x-0 md:items-center md:space-y-8 justify-center space-x-8">
            <div class="flex bg-white shadow border border-black w-45% sm:w-11/12 md:w-10/12 h-auto">
            <div class="flex flex-col p-8 space-y-3 text-xl 2xl:text-1.5xl leading-loose sm:text-lg w-full ">
                <p class="text-center h-20 ">SPECULAR VS DIFFUSE WITH THE USE OF WATER</p>
                <div class="flex flex-col w-80 h-72 sm:h-52">
                    <p>Materials:</p>
                    <ul class="list-disc pl-10">
                        <li>Metal Basin</li>
                        <li>Fresh Water</li>
                    </ul>
                </div>
                <div class="flex justify-center">
                    <button @click="togglePostModal1" class="w-60 h-12 bg-BGcolor4 rounded-full">
                    <p class="text-xl sm:text-lg 2xl:text-1.5xl text-center">View More</p>
                </button>
                </div>
            </div>
            </div>
        
        <div class="flex bg-white shadow border border-black w-45% sm:w-11/12 md:w-10/12 h-auto">
            <div class="flex flex-col p-8 space-y-3 text-xl 2xl:text-1.5xl sm:text-lg leading-loose w-full ">
                <p class="text-center h-20 ">SPECULAR VS DIFFUSE WITH THE USE OF WATER</p>
                <div class="flex flex-col w-80 h-72 sm:h-52">
                    <p>Materials:</p>
                    <ul class="list-disc pl-10">
                        <li>Piece of flat  wood/ lab table</li>
                        <li>2 Flashlights</li>
                        <li>1 Plane mirror</li>
                        <li>1 square container</li>
                        <li>plastic. paper cup</li>
                        <li>water</li>
                    </ul>
                </div>
                <div class="flex justify-center">
                    <button @click="togglePostModal2" class="w-60 h-12 bg-BGcolor4 rounded-full">
                    <p class="text-xl sm:text-lg 2xl:text-1.5xl text-center">View More</p>
                </button>
                </div>
            </div>
            </div>
        </div>
        
        <div class="flex justify-center">
        <div class="bg-white shadow border border-black w-93% sm:w-11/12 md:w-10/12 h-auto p-8">
            <div class="flex flex-col space-y-3 text-xl 2xl:text-1.5xl sm:text-lg leading-loose">
                <p class="">REMEMBER!</p>
                    <ul class="list-disc pl-10">
                        <li>Specular reflection is off to a smooth surface</li>
                        <li>Diffuse reflection is visible in rough surface</li>
                        <li>Law of reflection: the angle of reflection (that the ray makes with the normal to a surface) equals the angle of incidence.</li>
                        <li>note that all angles are measured with respect to the “normal”</li>
                    </ul>
            </div>
        </div>
        </div>

        <div class="flex flex-col space-y-8 p-4 leading-loose text-justify ">
          <h2 class="text-4xl sm:text-3xl 2xl:text-5xl font-bold">Let’s Discuss!</h2>
          <p class="text-lg sm:text-base 2xl:text-xl"><span class="pl-9">When</span> a ray of light approaches a smooth polished surface and the light ray bounces back, it is called the reflection of light. The incident light ray which lands upon the surface is said to be reflected off the surface. The ray that bounces back is called the reflected ray. Reflection of light law states that; the angle of reflection and incident ray are congruent to each other and it both lies in the same plane.</p>
          <div class="flex justify-center">
            <img src="../assets/imgs/lesson2/1.png" class="w-9/12 2xl:w-7/12 h-auto">
          </div>
          <p class="italic text-lg text-black text-center">Figure 3: Reflection of Light</p>
          <div class="flex w-8/12 break-all h-auto mx-auto text-center pb-6">
            <p class="text-base sm:text-sm 2xl:text-lg">https://www.kofastudy.com/courses/jss3-basic-science-2nd-term/lessons/reflection-of-light-week-2/topic/reflection-of-light/</p>          
          </div>
          <p class="text-lg sm:text-base 2xl:text-xl"><span class="pl-9 font-bold text-xl">Specular reflection</span> refers to a clear and sharp reflection like the ones you get in a mirror. This reflective surface reflects almost all the light incident on it uniformly. There is not much variation in the angles of reflections between various points. This means that the haziness and the blurring are almost eliminated.<br/>Meanwhile,</p>
          <p class="text-lg sm:text-base 2xl:text-xl"><span class="pl-9 font-bold text-xl">Diffuse reflection</span> is the reflection that is observed in a rough surface these often happen when the material or object has a rough texture or sometimes due to a disturbance. In this experiment, the difference between the specular and diffuse reflection was shown and this aims to understand the significant difference between these two types of experiments.</p>
          <div class="flex justify-center">
            <img src="../assets/imgs/lesson2/2.png" class="w-9/12 2xl:w-7/12 h-auto">
          </div>
          <p class="italic text-lg text-black text-center">Figure 4: Specular Vs. Diffuse Reflection</p>
          <div class="flex break-all w-8/12 h-auto mx-auto text-center pb-6">
            <p class="text-base sm:text-sm 2xl:text-lg">https://www.pngkit.com/view/u2q8u2o0y3w7t4i1_58774-p022aspecular-and-diffuse-reflection-gcse/</p>          
          </div>
        </div>

        <div class="space-y-8 ">
        <p class="text-4xl sm:text-3xl 2xl:text-5xl mt-14 sm:mt-10 md:mt-12">REFERENCES</p>
        <div class="flex flex-col space-y-5 leading-5 text-lg sm:text-base 2xl:text-xl">
        <p>[1] The Star Garden: Reflection, Refraction, and Diffraction. August 06, 2017</p>
        <p>[2] Reflection of Light - Introduction I Olympus Life Science: Introduction to the Reflection of Light, October 01, 2020.</p>
        <p>[3] B. Aronov et al, Discrete and Computational Geometry: Visibility with One Reflection, USA: Brooklyn, 1998</p>
        <p>[4] Optics 4 Kids: All Things Equal, October 01, 2020. </p>
        <p>[5] The Physics Classroom: Physics Tutorial: Specular vs. Diffuse Reflection, October 01, 2020</p>
        <p>[6] Science Primer: Specular vs. Diffuse Reflection, October 01, 2020.</p>
        <p>[7]“Introduction to the Reflection of Light,” Reflection of Light - Introduction | Olympus Life Science. [Online] Available: <a href="https://www.olympus-lifescience.com/en/microscope-resource/primer/lightandcolor/reflectionintro/" class="break-all">https://www.olympus-lifescience.com/en/microscope-resource/primer/lightandcolor/reflectionintro/.</a> [Accessed: 01-Oct-2020]. </p>
        <p>[8]T. R. Bullett, “Specular reflection,” science direct, 1999. [Online]. Available: <a href="https://www.sciencedirect.com/topics/engineering/specular-reflection" class="break-all">https://www.sciencedirect.com/topics/engineering/specular-reflection.</a> [Accessed: 2020].</p>
        <p>[9] L. B. Wolff "Relative brightness of specular and diffuse reflection," Optical Engineering 33(1), (1). <a href="https://doi.org/10.1117/12.149144" class="break-all">https://doi.org/10.1117/12.149144</a> January 1994</p>
        </div>
      </div>
      </div>

    <Lesson2modal1 v-if="modal1" @closeModal1="listener1"/>
    <Lesson2modal2 v-if="modal2" @closeModal2="listener2"/>
  </div>
  <Footer/>
  </div>
</template>

<script>
import Navbar from "@/views/nav"
import Footer from "@/views/footer"
import Lesson2modal1 from '@/components/lesson2modal1.vue';
import Lesson2modal2 from '@/components/lesson2modal2.vue';
  export default {
    data() {
      return {
        activeBtn: 0,
        modal1 : false,
        modal2 : false,
      };
    },

    components: {
      Navbar,
      Footer,
      Lesson2modal1,
      Lesson2modal2,
    },

    methods: {
    togglePostModal1(){
        this.modal1 = !this.modal1
      },
      listener1(){
      this.modal1 = false;
      },
      togglePostModal2(){
        this.modal2 = !this.modal2
      },
      listener2(){
      this.modal2 = false;
      },
    },
};
</script>

<style scoped>

</style>